import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueMask from 'v-mask'

Vue.use(VueMask)
Vue.use(Vuetify);

export default new Vuetify({
});
